module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA10lEQVR4AWOgD7BvhyOLxJo/N8Ig6O0kl2saGsgIi4Y1y9Mgqj+v9b6uo0lAg0pow89r4UDVPw4H3jTTAaogoGHKzCyg6t+XQu66GwClCWgQ9Wn+fDkCqOFxkjmm0gfR0V9PnULRUNudD1T9stEeq9L/YIDQwOnS+vx01IcF7riUomtIrSn+utPvhoEWptKff35tv3midPs0xe4wqHpmx7afp4Ju2+shK7337tmEo6u9F5Zx1rswVNlCEQT8vhL6IMwEohRuGEgaE0HAswJroFK4YfjQoAQAR47Z5xmI8gIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SC.png
// module id = 1257
// module chunks = 0